import React from 'react'
import { ClipboardList } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

const EmptyState: React.FC = () => {
  const { t } = useI18n();
  return(
    <div className='text-center py-6'>
    <div className='flex justify-center mb-3'>
      <ClipboardList className='text-muted h-12 w-12' />
    </div>
    <h3 className='text-foreground font-medium'>{t('betBuilder.noBetsSelected')}</h3>
    <p className='text-muted text-sm mt-1'>
      {t('betBuilder.addSelections')}
    </p>
  </div>
  )
  
}

export default EmptyState
